<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="/home" title="Home">Home</a></li>
                            <li>Relatórios / Enabley</li>
                        </ul>
                    </section>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Relatórios / Enabley</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <button type="button" class="btn-large-40 btn-red uppercase" @click="exportarRelatorioEmExcel(filter)">Gerar relatório de colaboradores</button>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>

    import auth from '@/common/auth'
    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: 'relatorios',
        mixins: [base],
        data() {

            return {

                resources: {
                    filter: 'colaborador',
                },

                filter: {
                    attributeBehavior: "ObterListagemColaboradoresParaRelatorioEnabley",
                },
            }
        },
        methods: {
            exportarRelatorioEmExcel:
                function () {
                    this.showLoading();
                    new Api('colaborador/ExportarRelatorioEnabley').export(
                        this.filter
                    ).then(data => {
                        var blob = new Blob([data], {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        });

                        var _a = document.createElement("a");
                        document.body.appendChild(_a);
                        _a.style.visibility = 'hidden';
                        _a.target = "_blank";
                        _a.href = window.URL.createObjectURL(blob);
                        _a.download = "TK2-admin-bulk-upload-template.xlsx"
                        _a.click();
                        _a.remove();

                        this.hideLoading();
                    });
                }
        },
    };
</script>